export default "__VITE_ASSET__BCV0O76p__";